import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const ExpandIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props} viewBox="0 0 48 48">
    <title>Expand</title>
    <polygon points="16.02 41 33.49 23.53 41 31.04 41 7 16.96 7 24.47 14.51 7 31.98 16.02 41" />
  </IconBase>
);
